export default __webpack_public_path__ + "static/media/downloadDoc.3e859c36.svg";